import { render, staticRenderFns } from "./SavedReports.vue?vue&type=template&id=4bd0351b"
import script from "./SavedReports.vue?vue&type=script&lang=js"
export * from "./SavedReports.vue?vue&type=script&lang=js"
import style0 from "./SavedReports.vue?vue&type=style&index=0&id=4bd0351b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports